import React from "react";
import ValueChip from "./ValueChip";
import type { RequirementRow as RequirementRowData } from "../data/requirementsData";

interface RequirementRowProps {
  row: RequirementRowData;
  isAcknowledged: boolean;
  onToggle: (id: string) => void;
}

// Parses "{bold|text}" markers in a detail string into React nodes
function parseDetail(text: string): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  const regex = /\{bold\|([^}]+)\}/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(<strong key={match.index}>{match[1]}</strong>);
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
}

const RequirementRow = ({
  row,
  isAcknowledged,
  onToggle,
}: RequirementRowProps) => {
  const { id, label, detail, chip, required, isOptional } = row;
  return (
    <div
      className={`reqRow${isAcknowledged ? " reqRow--acknowledged" : ""}`}
      onClick={() => onToggle(id)}
    >
      <div className="reqRow__checkWrap">
        <div
          className={`reqRow__checkbox${isAcknowledged ? " reqRow__checkbox--checked" : ""}`}
        >
          <span className="reqRow__checkIcon">✓</span>
        </div>
      </div>
      <div className="reqRow__body">
        <div className="reqRow__label">{label}</div>
        <div className="reqRow__detail">{parseDetail(detail)}</div>
        {chip && <ValueChip label={chip.label} variant={chip.variant} />}
        <div
          className={`reqRow__required${isOptional ? " reqRow__required--optional" : ""}`}
        >
          {required}
        </div>
      </div>
    </div>
  );
};

export default RequirementRow;
